export const GET_DASHBOARD_DATA_REQUEST_FEE = 'GET_DASHBOARD_DATA_REQUEST_FEE';
export const GET_DASHBOARD_DATA_SUCCESS_FEE = 'GET_DASHBOARD_DATA_SUCCESS_FEE';
export const GET_DASHBOARD_DATA_FAILURE_FEE = 'GET_DASHBOARD_DATA_FAILURE_FEE'; 

export const GET_DASHBOARD2_DATA_REQUEST_FEE = 'GET_DASHBOARD2_DATA_REQUEST_FEE';
export const GET_DASHBOARD2_DATA_SUCCESS_FEE = 'GET_DASHBOARD2_DATA_SUCCESS_FEE';
export const GET_DASHBOARD2_DATA_FAILURE_FEE = 'GET_DASHBOARD2_DATA_FAILURE_FEE';  